<template>
  <b-card @click="onClick" type="button" body-class="d-flex p-2" class="card-box-hover-rise text-center mb-4 h-100" :class="{'card-box-hover-rise-active': isActive}">
    <div class="m-auto">
      <AppSvgIcon height="3rem" :icon="icon" :tooltip="$t(text) | capitalize"/>
      <h5 class="text-primary my-2">{{$t(text) | capitalize}}</h5>
    </div>
  </b-card>
</template>

<script>
  export default {
    name: "AppPageOptionBox",
    props: {
      icon: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      isActive: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick() {
        this.$emit("onClick");
      }
    }
  }
</script>

<style scoped>

</style>
